var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.75H16M4 12.25H7M10 12.25H13M3.4 16H13.6C14.4401 16 14.8601 16 15.181 15.7956C15.4632 15.6159 15.6927 15.329 15.8365 14.9762C16 14.5751 16 14.0501 16 13V4C16 2.9499 16 2.42485 15.8365 2.02377C15.6927 1.67096 15.4632 1.38413 15.181 1.20436C14.8601 1 14.4401 1 13.6 1H3.4C2.55992 1 2.13988 1 1.81901 1.20436C1.53677 1.38413 1.3073 1.67096 1.16349 2.02377C1 2.42485 1 2.9499 1 4V13C1 14.0501 1 14.5751 1.16349 14.9762C1.3073 15.329 1.53677 15.6159 1.81901 15.7956C2.13988 16 2.55992 16 3.4 16Z",
    stroke: "#3C4242",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card_icon.2760df574c6f1b8188ea1023ae0e6123.svg";
export { ForwardRef as ReactComponent };